import React from 'react';
import { cn } from './cn';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, className }) => (
  <div className={cn('flex flex-col items-center justify-center text-center px-6 py-16', className)}>
    {icon && <div className="mb-4 text-text-tertiary">{icon}</div>}
    <h3 className="text-h3 font-display font-semibold text-text-primary mb-2">{title}</h3>
    {description && <p className="text-body text-text-secondary max-w-sm mb-6">{description}</p>}
    {action}
  </div>
);
